import { Stack, Textarea, TextInput } from '@mantine/core';
import type { BrandIdentityConfig, ExportBrandingConfigData } from '../types';
import SectionHeader from './SectionHeader';

type Props = {
  config: ExportBrandingConfigData;
  onChange: (config: ExportBrandingConfigData) => void;
};

export default function BrandIdentitySection({ config, onChange }: Props) {
  const identity = config.identity;

  const handleChange = (updated: BrandIdentityConfig) => {
    onChange({ ...config, identity: updated });
  };

  return (
    <Stack gap="md">
      <SectionHeader
        title="Brand identity"
        subtitle="Identity strings rendered into chart wordmarks, slide footers, and document covers."
      />
      <TextInput
        label="Wordmark"
        description="Text rendered as the brand wordmark in chart top-bars and slide footers."
        placeholder="Defaults to the company name"
        value={identity.wordmark ?? ''}
        onChange={e => handleChange({ ...identity, wordmark: e.currentTarget.value || null })}
      />
      <Textarea
        label="Footer disclaimer"
        description="Optional regulatory or compliance text shown at the bottom of generated documents and dashboards."
        placeholder="e.g. Past performance is not a reliable indicator of future results."
        value={identity.footer_disclaimer ?? ''}
        onChange={e =>
          handleChange({ ...identity, footer_disclaimer: e.currentTarget.value || null })
        }
        autosize
        minRows={2}
        maxRows={5}
      />
    </Stack>
  );
}
